import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { employeeDropdownForJobLoading, getJobPrefixLoading, getJobsheetTatLoading, getJobsheetTrend, getJobsheetView } from "src/store/actions";
import { RootReducerState } from "src/store/reducers";
import DropdownInput from "src/components/UI/DropdownInput";
import { Form, Formik } from "formik";
import InputCom from "src/components/Common/Input";
import Button from "src/components/UI/Button";
import { LazyTableState } from "src/models/components/dataTableWrapperModel";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { formatDateTOYYYYMMDD, hasAdminOrEmployeeRoleHandler } from "src/helpers/common_helpers";
import { Column } from "primereact/column";
import UIButton from 'src/components/UI/Button'
import { Link, useNavigate } from "react-router-dom";
import { ROUTER } from "src/constants/routes";
import FeatherIcon from "feather-icons-react";
import { Dialog } from "primereact/dialog";
import GroupChatView from "../JobSheets/JobSheets/chat/GroupChatView";
import "./jobsheettat.scss"
import { IconBase } from "primereact/iconbase";
import IconDripicons from "../Icons/IconDripicons";
import { clearJobsheetTatMessage, getJobPrefixExcelLoading } from "src/store/jobsheetTat/action";
import { useToast } from "src/components/Common/ReactToaster";

interface TrendProps {
  date?: any
  realDate?: any;
  userId?: any;
  showSub?: boolean;
}

const convertTimesToSeconds = (seconds: any) => {
  let years = Math.floor(seconds / (60 * 60 * 24 * 365));
  seconds %= (60 * 60 * 24 * 365);
  let months = Math.floor(seconds / (60 * 60 * 24 * 30));
  seconds %= (60 * 60 * 24 * 30);
  let days = Math.floor(seconds / (60 * 60 * 24));
  seconds %= (60 * 60 * 24);
  let hours = Math.floor(seconds / (60 * 60));
  seconds %= (60 * 60);
  let minutes = Math.floor(seconds / 60);
  let remainingSeconds = seconds % 60;
  let output = [];
  if (years > 0) {
    output.push(`${years} year${years > 1 ? 's' : ''}`);
  }
  if (months > 0) {
    output.push(`${months} month${months > 1 ? 's' : ''}`);
  }
  if (days > 0) {
    output.push(`${days} day${days > 1 ? 's' : ''}`);
  }
  if (hours > 0) {
    output.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  }
  if (minutes > 0) {
    output.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
  }
  if (remainingSeconds > 0) {
    output.push(`${remainingSeconds.toFixed(1)} second${remainingSeconds > 1 ? 's' : ''}`);
  }
  if (output.length === 0) {
    return "";
  } else {
    return output.join(", ");
  }
};

// Subcategory definitions
const SUBCATEGORIES: Record<string, string[]> = {
  mount: [
    "Confirmation received from Dealer",
    // "Part Received Confirmation",
    "Vehicle Under Observation",
    // "Part Replaced",
    // "Defective Part Scanned",
    // "Part Replaced Confirmation",
  ],
  dealer: [
    "Appointment Scheduled",
    "Waiting for Appointment",
    "Waiting for defect part",
    "Awaiting for Necessory information",
    "Waiting for re-Appointment",
    "Awaiting  for Confirmation from Dealer"
  ],
  customer: [
    "Awaiting  for confirmation from Customer",
    "Appointment Scheduled",
    "Waiting for Appointment",
    "Waiting for defect part",
    "Awaiting for Necessory information",
    "Waiting for re-Appointment",
    "Awaiting  for Confirmation from Dealer"
  ],
  supplier: [
    "Awaiting  for updated Software release",
    "Awaiting Supplier Approval / Advice",
    "Waiting  for Part",
    "Supplier Advice"
  ],
  courier: [
    "Defect Part under Transit",
    // "Part dispatched from Mount",
    // "Part Delivered Confirmation",
    // "Incoming Courier Created",
    // "Part pickup to Mount"
  ],
  nonpending: [
    "Job Sheet Created",
    "Assigned To Estimator",
    "Job Estimated Awaiting Approval",
    "Job Assignable To Technician",
    "Assigned To Technician",
    // "Ready To Invoice",
    // "Invoiced Job",
    // "Franchise Job Completed",
    "Estimation Rejected"
  ]
};

const getNameString = (str: string): string => {
  switch (str) {
    case "Part dispatched from Mount":
      return "Part Dispatched / In transit";
    case "Part Delivered Confirmation":
      return " Replacement Part Delivered / Awaiting Replacement";
    case "Incoming Courier Created":
      return "Defective part pickup arranged";
    case "Part pickup to Mount":
      return "Defective Part Picked / In transit";
    case "Part Received Confirmation":
      return "Defect Part Reached HO";
    default:
      return str;
  }
}

const JobsheetTat = ({ date, realDate, userId, showSub = false }: TrendProps) => {
  const dispatch = useDispatch();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(new Date().getDate() - 7);
  const filterDetails: DataTableFilterMeta = {
    JobCreationStartDate: { value: formatDateTOYYYYMMDD(sevenDaysAgo), matchMode: "contains" },
    JobCreationEndDate: { value: formatDateTOYYYYMMDD(new Date()), matchMode: "contains" },
    JobPrefix: { value: "all", matchMode: "contains" },
    type: { value: "all", matchMode: "contains" },
    jobConveterGuid: { value: showSub ? JSON.parse(localStorage.getItem("authUser") || "")?.uid : "", matchMode: "contains" },
  };
  const { showToast } = useToast();
  const { jobsheetTatValue, jobPrefixList } = useSelector((state: RootReducerState) => state.dashboard);
  const { employeeList } = useSelector((state: RootReducerState) => state.jobsheetReducer);
  const { profile } = useSelector((state: RootReducerState) => state.profilesReducer);
  const { jobsheetView } = useSelector((state: RootReducerState) => state.jobsheetReducer);
  const { loading, message } = useSelector((state: RootReducerState) => state.jobsheetTatReducer);

  const [tatStatus, setTatStatus] = useState("all");
  const [dropdownOpen, setDropdownOpen] = useState<Record<string, boolean>>({});
  const [selectedSubcategories, setSelectedSubcategories] = useState<Record<string, string[]>>({
    mount: [],
    dealer: [],
    customer: [],
    supplier: [],
    courier: [],
    nonpending: []
  });
  const dropdownRef = useRef<any>({});

  const [openFor, setOpenFor] = useState<any>({
    mount: false,
    dealer: false,
    customer: false,
    supplier: false,
    courier: false,
    nonpending: false,
    open: false,
    closed: false,
  });

  const jobTatValue = useMemo(() => {
    if (tatStatus == "closed") {
      return jobsheetTatValue?.filter((data: any) => data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed");
    } else if (tatStatus == "open") {
      return jobsheetTatValue?.filter((data: any) => data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed");
    } else {
      return jobsheetTatValue;
    }
  }, [jobsheetTatValue, tatStatus]);

  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [jobTatValue]);

  useEffect(() => {
    dispatch(getJobPrefixLoading());
    dispatch(employeeDropdownForJobLoading());
  }, []);

  useEffect(() => {
    if (message) {
      showToast(message, { type: "success" });
      setTimeout(() => {
        dispatch(clearJobsheetTatMessage());
      }, 1000);
    }
  }, [message]);

  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 5000,
    page: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const [lazyState, setLazyState] = useState<any>(initialLazyState);
  const [filteredTableData, setFilteredTableData] = useState(jobTatValue);
  const [filteredChartData, setFilteredChartData] = useState([]);

  const filterJobTatData = (jobType: string, bucketLabel: string) => {
    const bucket = buckets.find(b => b.label === bucketLabel);
    if (!bucket) return;

    const filtered = [...(filteredChartData.length > 0 ? filteredChartData : jobTatValue)]?.filter((item: any) => {
      const hoursMatch = bucket.condition(item.totalHours);

      if (jobType === 'Exchange') {
        return item.isExchange === true && hoursMatch && item.technicianUserType != "Franchise";
      }

      if (jobType === 'Remote') {
        return (item.technicianUserType == "Franchise" || item.jobType == "Remote") && hoursMatch;
      }

      if (jobType === 'InHouse') {
        return item.technicianUserType != "Franchise" && hoursMatch && (item.jobType == "InHouse" || !item.jobType) && item.isExchange != true;
      }

      return item.jobType === jobType && item.isExchange != true && hoursMatch;
    });

    setFilteredTableData(filtered);
  };

  const [chartSeries, setChartSeries] = useState<any>([]);

  const options: any = {
    chart: {
      type: 'bar',
      stacked: true,
      stackType: 'normal',
      height: 350,
      events: {
        dataPointSelection: (event: any, chartContext: any, config: any) => {
          const seriesIndex = config.seriesIndex;
          const dataPointIndex = config.dataPointIndex;

          const selectedJobType = ['InHouse', 'Exchange', 'Remote'][seriesIndex];
          const selectedBucket = [
            '⬆️ 144 Hours',
            '144 Hours',
            '96 Hours',
            '72 Hours',
            '48 Hours',
            '24 Hours',
          ][dataPointIndex];

          filterJobTatData(selectedJobType, selectedBucket);
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 10,
            style: {
              fontSize: '12px',
              fontWeight: 400,
            },
          },
        },
      },
    },
    xaxis: {
      categories: [
        '⬆️ 144 Hours',
        '144 Hours',
        '96 Hours',
        '72 Hours',
        '48 Hours',
        '24 Hours',
      ],
    },
    dataLabels: {
      enabled: true,
    },
    colors: ['#4B9FE1', '#EF476F', '#0edf7f'],
    legend: {
      position: 'top',
    },
  };

  const isAnySelected = useMemo(() => {
    return Object.keys(openFor)?.filter((k: any) => k != "totalClose")?.some((data: any) => openFor[data])
  }, [openFor])

  const buckets = [
    { label: '⬆️ 144 Hours', condition: (hours: number) => hours > 144 },
    { label: '144 Hours', condition: (hours: number) => hours <= 144 && hours > 96 },
    { label: '96 Hours', condition: (hours: number) => hours <= 96 && hours > 72 },
    { label: '72 Hours', condition: (hours: number) => hours <= 72 && hours > 48 },
    { label: '48 Hours', condition: (hours: number) => hours <= 48 && hours > 24 },
    { label: '24 Hours', condition: (hours: number) => hours <= 24 },
  ];

  const series = ['InHouse', 'Exchange', 'Remote'].map((jobType) => {
    const data = buckets.map((bucket) => {
      return [...((filteredChartData.length > 0 || isAnySelected) ? filteredChartData : jobTatValue)]?.filter((item: any) => {
        const hoursMatch = bucket.condition(item.totalHours);

        if (jobType === 'Exchange') {
          return item.isExchange == true && hoursMatch && item.technicianUserType != "Franchise";
        }

        if (jobType === 'Remote') {
          return (item.technicianUserType == "Franchise" || item.jobType == "Remote") && hoursMatch;
        }

        if (jobType === 'InHouse') {
          return item.technicianUserType != "Franchise" && hoursMatch && (item.jobType == "InHouse") && item.isExchange != true;
        }

        return item.jobType === jobType && item.isExchange != true && hoursMatch;
      }).length || 0;
    });

    return {
      name: jobType === 'InHouse' ? 'In House' : jobType == "Remote" ? "Field" : jobType,
      data,
    };
  });

  useEffect(() => {
    setChartSeries(series);
  }, [jobTatValue, filteredChartData, openFor]);

  const toggleDropdown = (cardType: string) => {
    setDropdownOpen(prev => ({
      ...prev,
      [cardType]: !prev[cardType]
    }));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isOutside = Object.keys(dropdownRef.current).every(key => {
        const ref = dropdownRef.current[key];
        return ref && !ref.contains(event.target);
      });

      if (isOutside) {
        setDropdownOpen({});
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubcategoryChange = (cardType: string, subcategory: string, checked: boolean, event: any) => {
    if (event) {
      event.stopPropagation(); // Prevent event bubbling
    }
    setSelectedSubcategories(prev => {
      const current = prev[cardType] || [];
      if (checked) {
        return { ...prev, [cardType]: [...current, subcategory] };
      } else {
        return { ...prev, [cardType]: current.filter(s => s !== subcategory) };
      }
    });
  };

  // const onCardClick = (type: any) => {
  //   debugger
  //   // When card is clicked, select all subcategories if not already selected\
  //   let data = selectedSubcategories
  //   let isOpen = openFor[type]
  //   debugger

  //   if (SUBCATEGORIES[type] && isOpen) {
  //     setSelectedSubcategories(prev => ({
  //       ...prev,
  //       [type]: []
  //     }));
  //   }

  //   setOpenFor((prevState: any) => ({
  //     ...prevState,
  //     [type]: !prevState[type],
  //     totalClose: false,
  //   }));

  //   // Close dropdown when toggling off
  //   if (openFor[type]) {
  //     setDropdownOpen(prev => ({ ...prev, [type]: false }));
  //   }
  // };

  const onCardClick = (type: any) => {
    const isCurrentlyOpen = openFor[type];

    // If we're closing the card (it's currently open), clear subcategories
    if (isCurrentlyOpen && SUBCATEGORIES[type]) {
      setSelectedSubcategories(prev => ({
        ...prev,
        [type]: []
      }));
      setDropdownOpen(prev => ({ ...prev, [type]: false }));
    }

    // Toggle the card state
    setOpenFor((prevState: any) => ({
      ...prevState,
      [type]: !prevState[type],
      totalClose: false,
    }));
  };

  const closedStatus = ["Franchise Job Completed", "Ready To Invoice", "Invoiced Job", "Job Closed"];

  useEffect(() => {
    if (!openFor.mount && !openFor.dealer && !openFor.supplier && !openFor.courier && !openFor.nonpending && !openFor.open && !openFor.closed && !openFor.totalClose && !openFor.customer) {
      setFilteredTableData(jobTatValue);
      setFilteredChartData([]);
      setKey((prev) => prev + 1);
      return;
    } else if (openFor.totalClose) {
      return;
    }

    const filtered = jobTatValue?.filter((data: any) => {
      // Check main category filters
      const mountMatch = openFor.mount && data?.inPending === true && data?.pendingReason === "mel" && !closedStatus.includes(data.status);
      const dealerMatch = openFor.dealer && data?.inPending === true && (data?.pendingReason === "dealer") && !closedStatus.includes(data.status);
      const customerMatch = openFor.customer && data?.inPending === true && data?.pendingReason === "customer" && !closedStatus.includes(data.status);
      const supplierMatch = openFor.supplier && data?.inPending === true && data?.pendingReason === "supplier" && !closedStatus.includes(data.status);
      const courierMatch = openFor.courier && data?.inPending === true && data?.pendingReason === "courier" && !closedStatus.includes(data.status);
      const nonpendingMatch = openFor.nonpending && data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status);
      const openMatch = openFor.open && data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed";
      const closedMatch = openFor.closed && (data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed");
      // Check subcategory filters
      let subcategoryMatch = true;

      if (mountMatch && selectedSubcategories.mount.length > 0) {
        subcategoryMatch = selectedSubcategories.mount.includes(data?.presentStatus);
      } else if (dealerMatch && selectedSubcategories.dealer.length > 0) {
        subcategoryMatch = selectedSubcategories.dealer.includes(data?.presentStatus);
      } else if (customerMatch && selectedSubcategories.customer.length > 0) {
        subcategoryMatch = selectedSubcategories.customer.includes(data?.presentStatus);
      } else if (supplierMatch && selectedSubcategories.supplier.length > 0) {
        subcategoryMatch = selectedSubcategories.supplier.includes(data?.presentStatus);
      } else if (courierMatch && selectedSubcategories.courier.length > 0) {
        subcategoryMatch = selectedSubcategories.courier.includes(data?.presentStatus);
      } else if (nonpendingMatch && selectedSubcategories.nonpending.length > 0) {
        subcategoryMatch = selectedSubcategories.nonpending.includes(data?.status);
      }

      return (mountMatch || dealerMatch || supplierMatch || courierMatch || nonpendingMatch || openMatch || closedMatch || customerMatch) && subcategoryMatch;
    });
    debugger
    setFilteredChartData(filtered?.length ? filtered : []);
    setFilteredTableData(filtered?.length ? filtered : []);
    setKey((prev) => prev + 1);
  }, [openFor, jobTatValue, selectedSubcategories]);

  let dummyData = useMemo(() => {
    return [
      {
        name: "Total Calls",
        count: jobsheetTatValue?.length,
        icon: "bx-pie-chart-alt-2"
      },
      ...((tatStatus == "closed" || tatStatus == "all") ? [{
        name: "Total Closed Call",
        count: jobTatValue?.filter((data: any) => data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed")?.length,
        icon: "bx-window-close",
        onClick: jobTatValue?.filter((data: any) => data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed")?.length > 0 ? () => onCardClick("closed") : () => { },
        active: openFor.closed
      }] : []),
      ...((tatStatus == "open" || tatStatus == "all") ? [{
        name: "Total Open Call",
        count: jobTatValue?.filter((data: any) => data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed")?.length,
        icon: "bx-check-circle",
        onClick: jobTatValue?.filter((data: any) => data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed")?.length > 0 ? () => onCardClick("open") : () => { },
        active: openFor.open
      }] : []),
      {
        name: "Open for mount",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "mel" && !closedStatus.includes(data.status))?.length,
        icon: "bx-user-circle",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "mel" && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("mount"),
        active: openFor.mount,
        hasSubcategories: true,
        type: "mount"
      },
      {
        name: "Open for Dealer",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == true && (data?.pendingReason == "dealer") && !closedStatus.includes(data.status))?.length,
        icon: "bx-user-check",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == true && (data?.pendingReason == "dealer") && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("dealer"),
        active: openFor.dealer,
        hasSubcategories: true,
        type: "dealer"
      },
      {
        name: "Open for Customer",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == true && (data?.pendingReason == "customer") && !closedStatus.includes(data.status))?.length,
        icon: "bx-user-check",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == true && (data?.pendingReason == "customer") && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("customer"),
        active: openFor.customer,
        hasSubcategories: true,
        type: "customer"
      },
      {
        name: "Open for Supplier",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "supplier" && !closedStatus.includes(data.status))?.length,
        icon: "bx-walk",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "supplier" && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("supplier"),
        active: openFor.supplier,
        hasSubcategories: true,
        type: "supplier"
      },
      {
        name: "Open for Courier",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "courier" && !closedStatus.includes(data.status))?.length,
        icon: "bx-package",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == true && data?.pendingReason == "courier" && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("courier"),
        active: openFor.courier,
        hasSubcategories: true,
        type: "courier"
      },
      {
        name: "Pending Free",
        count: tatStatus == "closed" ? 0 : jobTatValue?.filter((data: any) => data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status))?.length,
        icon: "bx-package",
        onClick: (tatStatus == "closed" || (jobTatValue?.filter((data: any) => data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status))?.length < 1)) ? () => { } : () => onCardClick("nonpending"),
        active: openFor.nonpending,
        hasSubcategories: true,
        type: "nonpending"
      },
    ];
  }, [jobTatValue, lazyState, openFor, tatStatus]);

  const handleSubmit = (values: any) => {
    setFilteredTableData([]);
    setFilteredChartData([]);
    setOpenFor({
      mount: false,
      dealer: false,
      customer: false,
      supplier: false,
      courier: false,
      nonpending: false,
      open: false,
      closed: false,
      totalClose: true,
    });
    if (values.type == "openCall") {
      setTatStatus("open");
    } else if (values.type == "closedCall") {
      setTatStatus("closed");
    } else if (values.type == "all") {
      setTatStatus("all");
    }
    setLazyState((prev: any) => {
      return {
        ...prev,
        filters: {
          ...prev.filters,
          JobCreationStartDate: { value: values.JobCreationStartDate },
          JobCreationEndDate: { value: values.JobCreationEndDate },
          JobPrefix: { value: values.JobPrefix },
          type: { value: values.type },
          jobConveterGuid: { value: values.jobConveterGuid },
        }
      };
    });
  };

  let colors = ["#0e86d4", "#db1f48", "#76b947", "#2555f1ff", "#fad02c", "#01949a", "#a020f0", "#ff7f50", "#8b4513"];

  useEffect(() => {
    return () => {
      setLazyState(initialLazyState)
    }
  }, [])
  const initialvalue = useMemo(() => {
    return {
      type: lazyState?.filters?.type?.value ? lazyState?.filters?.type?.value : "",
      JobPrefix: lazyState?.filters?.JobPrefix?.value ? lazyState?.filters?.JobPrefix?.value : "",
      jobConveterGuid: lazyState?.filters?.jobConveterGuid?.value ? lazyState?.filters?.jobConveterGuid?.value : "",
      JobCreationStartDate: lazyState?.filters?.JobCreationStartDate?.value ? formatDateTOYYYYMMDD(lazyState?.filters?.JobCreationStartDate?.value) : "",
      JobCreationEndDate: lazyState?.filters?.JobCreationEndDate?.value ? formatDateTOYYYYMMDD(lazyState?.filters?.JobCreationEndDate?.value) : "",
    };
  }, [lazyState]);

  const callBackFunction = useCallback((lazyData: any) => {
    let modifiedLazyData = {
      ...lazyData,
      filters: {
        ...lazyData.filters,
        type: { value: "", matchMode: "contains" },
        JobPrefix: { value: lazyData.filters.JobPrefix?.value == "all" ? "" : lazyData.filters.JobPrefix?.value, matchMode: "contains" },
        JobConveterGuid: { value: userId ? userId : "" },
      },
    };
    dispatch(getJobsheetTatLoading(modifiedLazyData));
  }, [userId]);

  useEffect(() => {
    callBackFunction(lazyState);
  }, [lazyState, userId]);

  const ThreeDaysFilter = (days: any) => {
    setFilteredTableData([]);
    setFilteredChartData([]);
    setOpenFor({
      mount: false,
      dealer: false,
      customer: false,
      supplier: false,
      courier: false,
      nonpending: false,
      open: false,
      closed: false,
      totalClose: true,
    });
    let today = new Date();
    let dateBefore = new Date(today.getTime() - days * 24 * 60 * 60 * 1000);
    setLazyState((state: any) => ({
      ...state,
      filters: {
        ...state.filters,
        JobCreationStartDate: { value: formatDateTOYYYYMMDD(dateBefore), matchMode: "contains" },
        JobCreationEndDate: { value: formatDateTOYYYYMMDD(today), matchMode: "contains" },
      },
    }));
  };

  const handleReset = (resetForm: any) => {
    resetForm(initialvalue);
    setFilteredTableData([]);
    setFilteredChartData([]);
    setOpenFor({
      mount: false,
      dealer: false,
      customer: false,
      supplier: false,
      courier: false,
      nonpending: false,
      open: false,
      closed: false,
      totalClose: true,
    });
    setSelectedSubcategories({
      mount: [],
      dealer: [],
      customer: [],
      supplier: [],
      courier: []
    });
    let today = new Date();
    let dateBefore = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
    setTatStatus("all");
    setLazyState((state: any) => ({
      ...state,
      filters: {
        ...state.filters,
        type: { value: "all", matchMode: "contains" },
        JobPrefix: { value: "all", matchMode: "contains" },
        JobCreationStartDate: { value: formatDateTOYYYYMMDD(dateBefore), matchMode: "contains" },
        JobCreationEndDate: { value: formatDateTOYYYYMMDD(today), matchMode: "contains" },
        jobConveterGuid: { value: JSON.parse(localStorage.getItem("authUser") || "")?.uid, matchMode: "contains" },
      },
    }));
  };



  const jobPrefixOptions = useMemo(() => {
    let data = jobPrefixList?.map((item: any) => ({ label: item.jobPrefix, value: item.jobPrefix }));
    return [
      { label: "All", value: "all" },
      ...data
    ];
  }, [jobPrefixList]);
  const navigate = useNavigate();

  const [openChat, setOpenChat] = useState<boolean>(false)
  const [jobId, setJobId] = useState(null)
  const onChatClick = (rowData: any) => {
    // const url = `${ROUTER.JOB_SHEETS_VIEW}/${rowData?.jobId}?status=open&source=chat`; // example query params
    // window.open(url, "_blank"); // opens in a new tab
    dispatch(getJobsheetView(rowData?.jobId))
    setJobId(rowData?.jobId)
    setOpenChat(true)
  };

  const chatIcon = (rowData: any) => {

    return (
      <div className="msg-icon-job" onClick={(e) => {
        e.stopPropagation();
        onChatClick(rowData)
      }}>
        <FeatherIcon icon="message-circle" />
        {rowData.notificationCount > 0 ? <span className="count">{rowData.notificationCount}</span> : null}
      </div>
    )
  }

  const employeeDropList = employeeList?.length > 0 ? (employeeList.map((eachEmployee: any) => {
    let data: any = {};
    data['value'] = eachEmployee.userId;
    data['label'] = eachEmployee.name;
    data['id'] = eachEmployee.id;
    return data;
  })) : [];

  const isAdmin = useMemo(() => {
    return (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true)
  }, [profile])

  const openChatModal = () => {
    return (
      <Dialog
        visible={openChat}
        onHide={() => { setOpenChat(false) }}
        header={
          (
            <span className='jobno'>Chat Of {jobsheetView?.number ? <>{jobsheetView?.number}</> : <>{jobsheetView?.jobPrefix}</>}</span>
          )
        }
        style={{ width: "800px", height: "85vh" }}
        contentStyle={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: "8px", // avoids scrollbar overlap
          }}
        >
          {/* <ChatPage id={id} /> */}
          <GroupChatView jobsheet={jobsheetView} id={jobId} />
        </div>
      </Dialog>
    )
  }

  const [jobPrefix, setJobPrefix] = useState<string>("")

  const prefixDownload = (prefix: string) => {
    dispatch(getJobPrefixExcelLoading(prefix))
  }

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  return (
    <React.Fragment>
      {openChat && jobId && openChatModal()}
      <Col xl={12}>
        <Card className="card-h-100">
          <CardBody>
            <div className="d-flex flex-wrap align-items-center mb-4">
              <h5 className="card-title me-2">Jobsheet Tat</h5>
              <div className="ms-auto">
                <div>
                  <b>{date}</b>
                </div>
              </div>
            </div>
            <Row className="align-items-center">
              <div className="d-flex w-100 flex-wrap" style={{ justifyContent: "space-between", alignItems: "center" }}>
                <div className="" style={{ width: "65%", minWidth: "750px" }}>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialvalue}
                    enableReinitialize
                  >
                    {({
                      values,
                      handleChange,
                      touched,
                      errors,
                      handleBlur,
                      resetForm,
                      reset,
                      isSubmitting,
                      ...rest
                    }: any) => {
                      return (
                        <Form onChange={handleChange}>
                          <Row>
                            <Col lg={2} md={4} sm={12}>
                              <DropdownInput
                                options={[
                                  { label: "All", value: "all" },
                                  { label: "Open Call", value: "openCall" },
                                  { label: "Closed Call", value: "closedCall" },
                                ]}
                                name="type"
                                label="Type"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                required={false}
                                value={values.type}
                                invalid={
                                  touched["type"] && errors["type"] ? true : false
                                }
                              />
                            </Col>
                            <Col lg={2} md={4} sm={12}>
                              <DropdownInput
                                options={jobPrefixOptions}
                                name="JobPrefix"
                                label="Job Prefix"
                                onChange={(e) => {
                                  handleChange(e);
                                  setJobPrefix(e.target.value === "all" ? "" : e.target.value);
                                }}
                                onBlur={handleBlur}
                                required={false}
                                value={values.JobPrefix}
                                invalid={
                                  touched["JobPrefix"] && errors["JobPrefix"] ? true : false
                                }
                              />
                            </Col>
                            {(showSub && isAdmin) &&
                              <Col lg={2} md={4} sm={12}>
                                <DropdownInput
                                  options={employeeDropList}
                                  name="jobConveterGuid"
                                  label="User"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  required={false}
                                  value={values.jobConveterGuid}
                                  invalid={
                                    touched["jobConveterGuid"] && errors["jobConveterGuid"] ? true : false
                                  }
                                />
                              </Col>
                            }
                            <Col lg={2} md={4} sm={12}>
                              <label htmlFor="JobCreationStartDate">From</label>
                              <Input
                                type="date"
                                required
                                name={"JobCreationStartDate"}
                                value={values.JobCreationStartDate}
                                onBlur={handleBlur}
                                max={values?.JobCreationEndDate ? values?.JobCreationEndDate : ""}
                                onChange={handleChange}
                                invalid={false}
                              />
                            </Col>
                            <Col lg={2} md={4} sm={12}>
                              <label htmlFor="from">To</label>
                              <Input
                                type="date"
                                required
                                name={"JobCreationEndDate"}
                                value={values.JobCreationEndDate}
                                onBlur={handleBlur}
                                min={values?.JobCreationStartDate ? values?.JobCreationStartDate : ""}
                                onChange={handleChange}
                                invalid={false}
                              />
                            </Col>
                            <Col lg={2} md={4} sm={12} className="align-self-end">
                              <div className="d-flex">
                                <Button
                                  className="secondary-btn me-2"
                                  label={"Reset"}
                                  type="button"
                                  onClick={() => handleReset(resetForm)}
                                />
                                <Button
                                  className="btn-primary btn-primary-shadow"
                                  label={"Search"}
                                  type="submit"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
                <div className="d-flex">
                  {jobPrefix && <UIButton
                    label={`${jobPrefix} Report`}
                    className={`btn-primary ms-2`}
                    type="button"
                    icon={"mail"}
                    onClick={() => { prefixDownload(jobPrefix) }}
                    disabled={loading}
                  ></UIButton>}
                  <UIButton
                    label={"Last 7 Days"}
                    className={`btn-primary ms-2`}
                    type="button"
                    onClick={() => { ThreeDaysFilter(7) }}
                    disabled={false}
                  ></UIButton>
                  <UIButton
                    label={"Last 15 Days"}
                    className={`btn-primary ms-2`}
                    type="button"
                    onClick={() => { ThreeDaysFilter(15) }}
                    disabled={false}
                  ></UIButton>
                  <UIButton
                    label={"Last 30 Days"}
                    className={`btn-primary ms-2`}
                    type="button"
                    onClick={() => { ThreeDaysFilter(30) }}
                    disabled={false}
                  ></UIButton>
                </div>
              </div>
              <div className="chart-data">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex flex-wrap mb-3 gap-2 mt-3">

                      {
                        dummyData?.map((item: any, index: any) => (
                          <div
                            key={index}
                            style={{ position: "relative" }}
                            ref={(el) => {
                              if (item.type) {
                                dropdownRef.current[item.type] = el;
                              }
                            }}
                          >
                            <div
                              className={`data-card ${item?.active ? "card-border" : ""}`}
                              id={`card-${item.type || index}`}
                              onClick={(e) => {
                                if (dropdownOpen[item.type]) {
                                  return;
                                }
                                if (item.onClick) {
                                  item.onClick();
                                }
                              }}
                              style={{ cursor: item.onClick ? "pointer" : "default" }}
                            >
                              <div className="d-flex flex-column justify-content-center align-items-start">
                                <div className="data-header">{item.name}</div>
                                <div className="data-body">{item.count}</div>
                              </div>
                              <div className="icon" style={{ backgroundColor: colors[index] }}>
                                <i className={`bx ${item.icon}`}></i>
                              </div>
                              {item.onClick &&
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`${item.type}`}
                                  checked={item.active}
                                  readOnly
                                  style={{
                                    position: "absolute",
                                    top: "5px",
                                    left: "5px",
                                    zIndex: 10,
                                    pointerEvents: "none"
                                  }}
                                />
                              }
                              {item.hasSubcategories && item?.active && (
                                <div
                                  className="subcategory-toggle"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleDropdown(item.type);
                                  }}
                                  style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "26px",
                                    height: "26px",
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    // border:`0.5px solid ${colors[index]}`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    zIndex: 10
                                  }}
                                >
                                  <i
                                    className={`bx ${dropdownOpen[item.type] ? 'bx-chevron-up' : 'bx-filter'}`}
                                    style={{ fontSize: "18px", color: colors[index] }}
                                  ></i>
                                </div>
                              )}
                            </div>

                            {item.hasSubcategories && SUBCATEGORIES[item.type] && dropdownOpen[item.type] && (
                              <div
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: "0",
                                  marginTop: "8px",
                                  backgroundColor: "white",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  zIndex: 1000,
                                  minWidth: "280px",
                                  padding: "12px"
                                }}
                              >
                                <div style={{ fontWeight: "600", marginBottom: "12px", fontSize: "14px", color: "#333" }}>
                                  Filter by Status:
                                </div>
                                <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                                  {SUBCATEGORIES[item.type].map((subcategory, subIndex) => {
                                    const isChecked = selectedSubcategories[item.type]?.includes(subcategory);
                                    const countSubCategory = jobTatValue?.filter((data: any) => {
                                      const statusMatch = data?.presentStatus === subcategory;
                                      const statusMatchForPendingFree = data?.status === subcategory;

                                      if (item.type === 'mount') {
                                        return statusMatch && data?.inPending === true && data?.pendingReason === "mel" && !closedStatus.includes(data.status);
                                      }
                                      if (item.type === 'dealer') {
                                        return statusMatch && data?.inPending === true && data?.pendingReason === "dealer" && !closedStatus.includes(data.status);
                                      }
                                      if (item.type === 'customer') {
                                        return statusMatch && data?.inPending === true && data?.pendingReason === "customer" && !closedStatus.includes(data.status);
                                      }
                                      if (item.type === 'supplier') {
                                        return statusMatch && data?.inPending === true && data?.pendingReason === "supplier" && !closedStatus.includes(data.status);
                                      }
                                      if (item.type === 'courier') {
                                        return statusMatch && data?.inPending === true && data?.pendingReason === "courier" && !closedStatus.includes(data.status);
                                      }
                                      if (item.type === 'nonpending') {
                                        return statusMatchForPendingFree && data?.inPending != true && !data?.pendingReason && !closedStatus.includes(data.status);
                                      }
                                      return false;
                                    }).length || 0;
                                    return (
                                      <div
                                        key={subIndex}
                                        className="form-check mb-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          handleSubcategoryChange(item.type, subcategory, !isChecked, e);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`${item.type}-${subIndex}`}
                                          checked={isChecked}
                                          readOnly
                                          style={{ cursor: "pointer", pointerEvents: "none" }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${item.type}-${subIndex}`}
                                          style={{ fontSize: "13px", cursor: "pointer", userSelect: "none" }}
                                        >
                                          {getNameString(subcategory)} - ({countSubCategory})
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                                <div style={{
                                  marginTop: "12px",
                                  paddingTop: "12px",
                                  borderTop: "1px solid #e0e0e0",
                                  display: "flex",
                                  gap: "8px",
                                  justifyContent: "flex-end"
                                }}>
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedSubcategories(prev => ({
                                        ...prev,
                                        [item.type]: []
                                      }));
                                    }}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedSubcategories(prev => ({
                                        ...prev,
                                        [item.type]: SUBCATEGORIES[item.type]
                                      }));
                                    }}
                                  >
                                    Select All
                                  </button>
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleDropdown(item.type);
                                    }}
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      }


                    </div>
                  </Col>
                  <Col lg={4} className="mt-3">
                    <ReactApexChart
                      key={key}
                      options={options}
                      series={chartSeries}
                      type="bar"
                      height={400}
                    />
                  </Col>
                  <Col lg={8} className="mt-3">
                    <div className="card ps-0 pe-0 dashboard-table" id="table-border">
                      <DataTable
                        size="large"
                        value={(filteredTableData.length > 0 || isAnySelected) ? filteredTableData : jobTatValue}
                        showGridlines
                        lazy
                        scrollable
                        scrollHeight="400px"
                        tableStyle={{ minWidth: '50rem', maxHeight: "500px" }}
                      >
                        <Column field="jobNumber" header="Job No" className='table-font'
                          body={(rowData: any) => {
                            if (rowData.jobId) {
                              return <Link to={`${ROUTER.JOB_SHEETS_VIEW}/${rowData.jobId}`}>{rowData.jobNumber ? rowData.jobNumber : "WIP"}</Link>
                            } else {
                              return rowData.jobNumber
                            }
                          }}
                        ></Column>
                        <Column field="jobNumber" header="Job Type" className='' body={(rowData: any) => {
                          if (rowData.isExchange && rowData.technicianUserType != "Franchise") {
                            return <div style={{ backgroundColor: "#EF476F", color: "white", textAlign: "center", borderRadius: "5px", fontWeight: "500" }}>Exchange</div>
                          }
                          else if (rowData.technicianUserType == "Franchise" || rowData.jobType == "Remote") {
                            return <div style={{ backgroundColor: "#0edf7f", color: "white", textAlign: "center", borderRadius: "5px", fontWeight: "500" }}>Field</div>
                          }
                          else if ((rowData.jobType == "InHouse" || !rowData.jobType) && rowData.technicianUserType != "Franchise") {
                            return <div style={{ backgroundColor: "#4B9FE1", color: "white", textAlign: "center", borderRadius: "5px", fontWeight: "500" }}>In House</div>
                          }
                        }}></Column>
                        <Column field="chat" header="Chat" className='table-font' body={(rowData: any) => chatIcon(rowData)}></Column>
                        <Column field="dealerTat" header="Dealer Tat" className='partSku table-font' body={(rowData: any) => convertTimesToSeconds(rowData?.dealerTat)}></Column>
                        <Column field="supplierTat" header="Supplier Tat" className='partSku table-font' body={(rowData: any) => convertTimesToSeconds(rowData?.supplierTat)}></Column>
                        <Column field="melTat" header="Mel Tat" className='partSku table-font' body={(rowData: any) => convertTimesToSeconds(rowData?.melTat)}></Column>
                        <Column field="courierTat" header="Courier Tat" className='partSku table-font' body={(rowData: any) => convertTimesToSeconds(rowData?.courierTat)}></Column>
                      </DataTable>
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default JobsheetTat;